// import defaultOfertaForm from '@/util/offerConfigurator/defaultOfertaForm.js'
// import {clone} from '@/util/libUtil.js'

const defaultAtencionForm = {
    comercial: null,
    cliente: null,
    fechaContacto: null,
    notas: null,
    estado: '',
}

export default defaultAtencionForm;
